__turbopack_context__.v({
  "className": "M0Jqla_className",
  "variable": "M0Jqla_variable",
});
